// Theme: light/dark/auto. Persists in localStorage; auto follows the OS.

export type ThemePref = 'light' | 'dark' | 'auto';
const KEY = 'erp.theme';

export function readPref(): ThemePref {
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' || v === 'auto' ? v : 'auto';
}

function effective(pref: ThemePref): 'light' | 'dark' {
  if (pref !== 'auto') return pref;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function applyTheme(pref: ThemePref): void {
  document.documentElement.dataset.theme = effective(pref);
}

export function setPref(pref: ThemePref): void {
  localStorage.setItem(KEY, pref);
  applyTheme(pref);
}

export function bootstrapTheme(): void {
  const pref = readPref();
  applyTheme(pref);
  // React to OS changes only when set to auto.
  window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => {
    if (readPref() === 'auto') applyTheme('auto');
  });
}
